export type StaffRole =
  | 'super_admin'
  | 'project_manager'
  | 'agronomist'
  | 'field_facilitator'
  | 'farmer';

export const STAFF_ROLES: StaffRole[] = [
  'super_admin', 'project_manager', 'agronomist', 'field_facilitator', 'farmer',
];

export const ROLE_PERMISSIONS: Record<StaffRole, string[]> = {
  super_admin: ['*'],
  project_manager: ['users:read', 'users:write', 'farmers:read', 'farmers:write', 'cohorts:read', 'cohorts:write', 'warehouse:read', 'warehouse:write', 'documents:read', 'documents:write'],
  agronomist: ['farmers:read', 'farmers:write', 'cohorts:read', 'cohorts:write', 'warehouse:read', 'warehouse:write'],
  field_facilitator: ['farmers:read', 'farmers:write', 'cohorts:read', 'vsla:read', 'vsla:write', 'documents:read', 'documents:write'],
  farmer: [],
};

export const isStaffRole = (role?: string | null): role is StaffRole => {
  if (!role) return false;
  return (STAFF_ROLES as string[]).includes(role);
};

export const isSuperAdmin = (role?: string | null): boolean => role === 'super_admin';
export const isSystemAdmin = (role?: string | null): boolean =>
  role === 'super_admin';
export const canManageUsers = (role?: string | null): boolean =>
  ['super_admin', 'project_manager'].includes(role || '');
